jQuery.fn.InitializeSearchPage = function (option) {
    var defaults = {
        initialJsonData: null,
        serviceUrl: null,
        typeAheadModelUrl: null,
        typeAheadServiceUrl: null
    };

    var option = $.extend({}, defaults, option);
    var viewModelJs = JSON.parse(option.initialJsonData);    
    var viewModel = ko.mapping.fromJS(viewModelJs);
    //force reit filter in services to have ServiceFilters ParentName    
    for(var i = 0;i<viewModel.SearchFilters.ServiceFilters().length; i++){
        var filter = viewModel.SearchFilters.ServiceFilters()[i]
        if(filter.Name().toLowerCase().indexOf('reit') > 0){
            filter.ParentName('ServiceFilters');
            break;
        }
    }
    var guidEmpty = '00000000-0000-0000-0000-000000000000';
    var keyWordIDKey = 'KEYWORD';
    var $scrollDefaultPosition = $('#results-top')
    var defaultScrollTop = $scrollDefaultPosition.offset().top
    var typeAheadTimer;
    var pageContent = $(this);
    var lastChangedType = '';
    viewModel.HasSearchRun = ko.observable(false);
    viewModel.IsSearchRunning = ko.observable(false);
    viewModel.IsSelectAll = ko.observable(false);
    viewModel.IsClearAll = ko.observable(false);
    viewModel.ScrollPositionUpdate = ko.observable(false);
    viewModel.HasPendingUpdates = ko.observable(false);
    viewModel.SelectedFilters = ko.observableArray();
    viewModel.TypeAheadResultGroup = ko.observableArray();
    viewModel.SearchBoxFocus = ko.observable(false);
    viewModel.KeywordSearching = ko.observable(false);
    viewModel.SearchBoxFocusThrottled = ko.computed(viewModel.SearchBoxFocus).extend({ throttle: 100 });
    viewModel.SubmissionFlag = ko.observable(false);

    //on init, if a search is already executing let's scroll to results
    if (window.location.search.indexOf('letter') > -1 || window.location.search.indexOf('keyword') > -1) {
        var scrollPosition = defaultScrollTop;
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
    }

    // Populate Results & Grid Data

    viewModel.LoadDataFromServer = function () {
        viewModel.IsSearchRunning(true);
        var viewModelToSend = GetRequestObject(viewModel.SearchFilters);

        $.ajax({
            url: option.serviceUrl,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            data: ko.mapping.toJSON(viewModelToSend),
            cache: false,
            success: function (data) {
                var results = ko.observableArray();
                var resultsUpcoming = ko.observableArray();
                if (viewModel.SearchFilters.Skip() == 0) {
                    viewModel.ResultCount(0);
                    viewModel.GridData.removeAll();
                }
                ko.mapping.fromJS(data.GridData, {}, results);
                ko.utils.arrayForEach(results(), function (item) {
                    viewModel.GridData.push(item);
                });

                viewModel.ResultCount(data.ResultCount);
                viewModel.HasMoreResults(data.HasMoreResults);
                viewModel.SearchFilters.KeywordFilter(viewModel.DecodeHtmlInput(data.SearchFilters.KeywordFilter));
                viewModel.SearchFilters.ReloadFilters(data.SearchFilters.ReloadFilters);
                viewModel.SetSelectedFilters();
                viewModel.HasPendingUpdates(false);
                viewModel.IsSearchRunning(false);
            },
            error: function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log("textStatus : " + textStatus);
                console.log("errorThrown : " + errorThrown);
            }
        });
    };

    viewModel.PopulateResults = function () {
        var currentState = History.getState();
        var qs = History.getState().data['qs'];
        var qsParms = !!qs ? parseQueryString(qs) : {};
        var currentSkip = viewModel.GridData().length;
        var newSkip = 0;

        if (!!qsParms.skip && qsParms.skip > 0) {
            newSkip = parseInt(qsParms.skip);
        }
        var projectedTotal = newSkip + viewModel.SearchFilters.Take();
        if (projectedTotal < currentSkip && newSkip != 0) {
            // This is here for a back button after a page scroll
            viewModel.IsSearchRunning(true);
            viewModel.HasMoreResults(true);
            viewModel.HasSearchRun(true);
            viewModel.SearchFilters.Skip(newSkip);
            while (viewModel.GridData().length > projectedTotal) {
                var popped = viewModel.GridData.pop();
            }
            viewModel.IsSearchRunning(false);
        } else {
            var existingFiltersTypeFilters = new Array();

            viewModel.SearchFilters.ClearAllSearchFilters();
            var hasFilters = false;
            var reloadFilters = false;

            if (!!qsParms.reload && qsParms.reload.length > 0) {
                reloadFilters = (qsParms.reload == "true");
            }

            viewModel.SearchFilters.ReloadFilters(reloadFilters);
            if (!!qsParms.keyword && qsParms.keyword.length > 0) {
                viewModel.SearchFilters.KeywordFilter(qsParms.keyword);
                hasFilters = true;
            }

            viewModel.SearchFilters.Skip(newSkip);
            if (!!qsParms.services && qsParms.services.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.ServiceFilters(), function (item) {
                    if (qsParms.services.indexOf(item.ID()) >= 0 ) {
                        if(!(item.ID() === '0a774288-0858-454b-af7c-1614bd4680df' && lastChangedType === 'IndustryFilters')){
                            item.IsSelected(true);
                            hasFilters = true;
                        }
                    }
                });
                ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                    if (qsParms.services.indexOf(item.ID()) >= 0) {
                        if(!(item.ID() === '0a774288-0858-454b-af7c-1614bd4680df' && lastChangedType === 'ServiceFilters')){
                            item.IsSelected(true);
                            hasFilters = true;
                        }
                    }
                });
            }

            if (!!qsParms.office && qsParms.office.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
                    if (qsParms.office.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }

            if (!!qsParms.school && qsParms.school.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.SchoolFilters(), function (item) {
                    if (qsParms.school.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }

            if (!!qsParms.level && qsParms.level.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.LevelFilters(), function (item) {
                    if (qsParms.level.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }

            if (!!qsParms.baradmission && qsParms.baradmission.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
                    if (qsParms.baradmission.indexOf(item.ID()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }

            if (!!qsParms.letter && qsParms.letter.length > 0) {
                ko.utils.arrayForEach(viewModel.SearchFilters.LetterFilters(), function (item) {
                    if (qsParms.letter.indexOf(item.Name()) >= 0) {
                        item.IsSelected(true);
                        hasFilters = true;
                    }
                });
            }

            // Sort
            var sort = "";
            if (!!qsParms.sort && qsParms.sort !== "") {
                sort = qsParms.sort;
                viewModel.SearchFilters.SortField(sort);
            }

            if (!viewModel.ScrollPositionUpdate()) {
                viewModel.LoadDataFromServer();
                viewModel.HasSearchRun(hasFilters);
            }
        }

        // Reposition by scroll position
        var scrollPosition = 0;
        if (!!qsParms.scroll && qsParms.scroll.length > 0) {
            scrollPosition = parseInt(qsParms.scroll);
        }
        $("html, body").animate({ scrollTop: scrollPosition }, "slow");
        return;
    };

    viewModel.LoadFromParameters = function () {
        viewModel.PopulateResults();
    };

    viewModel.Sort = function (sortField) {
        if (sortField === "position") {
            viewModel.SearchFilters.SortField("Position");
        } else {
            viewModel.SearchFilters.SortField("LastName");
        }
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    window.onstatechange = function () {
        viewModel.PopulateResults();
    };

    // Pagination

    viewModel.LoadNextPage = function () {
        viewModel.SearchFilters.Skip(viewModel.GridData().length);
        var qs = viewModel.QueryString();
        viewModel.ScrollPositionUpdate(false);
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
    };

    // Query string handling

    viewModel.QueryString = function (forceScrollPosition) {
        var queryString = "";
        var selectedItems = new Array();

        if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "keyword=" + encodeURIComponent(viewModel.SearchFilters.KeywordFilter());
        }

        ko.utils.arrayForEach(viewModel.SearchFilters.ServiceFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "services=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "office=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.SchoolFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "school=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.LevelFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "level=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.ID());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "baradmission=" + selectedItems.join();
        }

        selectedItems = new Array();
        ko.utils.arrayForEach(viewModel.SearchFilters.LetterFilters(), function (item) {
            if (item.IsSelected() == true) {
                selectedItems.push(item.Name());
            }
        });
        if (selectedItems.length > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "letter=" + selectedItems.join();
        }

        if (viewModel.SearchFilters.Skip() > 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "skip=" + viewModel.SearchFilters.Skip();
        }

        if (viewModel.SearchFilters.SortField() !== 0) {
            queryString += (queryString != "" ? "&" : "?");
            queryString += "sort=" + viewModel.SearchFilters.SortField();
        }

        queryString += (queryString != "" ? "&" : "?");
        queryString += "reload=" + viewModel.SearchFilters.ReloadFilters();

        queryString += (queryString != "" ? "&" : "?");
        if (!!forceScrollPosition && forceScrollPosition > 0) {
            queryString += "scroll=" + forceScrollPosition;
        } else {
            queryString += "scroll=" + $(window).scrollTop();
        }
        return queryString;
    };

    // Searching

    // Run search by pushing new state
    viewModel.Search = function () {
        var windowPosition = (viewModel.HasSelectedFilters()) ? defaultScrollTop : 1;

        if (viewModel.HasPendingUpdates() == false) {
            return;
        }

        viewModel.SearchFilters.Skip(0);
        var qs = viewModel.QueryString(windowPosition);
        viewModel.ScrollPositionUpdate(false);
        History.pushState({ qs: qs }, History.options.initialTitle, qs);
    };

    viewModel.KeywordSearch = function () {
        viewModel.SearchFilters.ClearLetterFilter();
        viewModel.SubmissionFlag(true);
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
        $('.text-input').blur();
    };

    viewModel.LetterSearch = function (letter) {
        viewModel.SearchFilters.ClearLetterFilter();
        viewModel.SearchFilters.ClearSearchFilter('KeywordFilter');
        ko.utils.arrayForEach(viewModel.SearchFilters.LetterFilters(), function (item) {
            if (item.Name() === letter) {
                item.IsSelected(true);
            }
        });
        viewModel.HasPendingUpdates(true);
        viewModel.Search();
    };

    // Filters

    viewModel.HasSelectedFilters = function () {
        if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.ServiceFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.IndustryFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.OfficeFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.SchoolFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.LevelFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }
        var hasItem = ko.utils.arrayFirst(viewModel.SearchFilters.LetterFilters(), function (item) {
            return (item.IsSelected() == true);
        });
        if (hasItem != null) {
            return true;
        }

        return false;
    };

    viewModel.SearchFilters.ClearAllSearchFilters = function (callBack) {
        viewModel.SearchFilters.KeywordFilter('');
        viewModel.SearchFilters.ClearAdvancedSearchFilters(callBack);
    };

    viewModel.SearchFilters.ClearLetterFilter = function () {
        ko.utils.arrayForEach(viewModel.SearchFilters.LetterFilters(), function (item) {
            item.IsSelected(false);
        });
    };

    viewModel.SearchFilters.ClearAdvancedSearchFilters = function (callBack) {
        ko.utils.arrayForEach(viewModel.SearchFilters.ServiceFilters(), function (item) {
            item.IsSelected(false);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
            item.IsSelected(false);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
            item.IsSelected(false);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.SchoolFilters(), function (item) {
            item.IsSelected(false);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.LevelFilters(), function (item) {
            item.IsSelected(false);
        });
        ko.utils.arrayForEach(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
            item.IsSelected(false);
        });

        viewModel.SearchFilters.ClearLetterFilter();

        if (!!callBack && $.isFunction(callBack)) {
            callBack();
        }
    };

    viewModel.SearchFilters.ClearSearchFilter = function (parentName) {
        if (parentName === "KeywordFilter") {
            viewModel.SearchFilters.KeywordFilter('');
        } else if (parentName === "LetterFilters") {
            viewModel.SearchFilters.ClearLetterFilter();
        } else if (parentName === "IndustryFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                item.IsSelected(false);
            });
        } else if (parentName === "ServiceFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.ServiceFilters(), function (item) {
                item.IsSelected(false);
            });
        } else if (parentName === "OfficeFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
                item.IsSelected(false);
            });
        } else if (parentName === "SchoolFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.SchoolFilters(), function (item) {
                item.IsSelected(false);
            });
        } else if (parentName === "LevelFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.LevelFilters(), function (item) {
                item.IsSelected(false);
            });
        } else if (parentName === "BarAdmissionFilters") {
            ko.utils.arrayForEach(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
                item.IsSelected(false);
            });
        };
    }

    viewModel.SetSelectedFilters = function () {
            viewModel.SelectedFilters.removeAll();
            if (viewModel.SearchFilters.KeywordFilter() != null && viewModel.SearchFilters.KeywordFilter().length > 0) {
                var newItem = {
                    ID: ko.observable(keyWordIDKey),
                    IsEnabled: ko.observable(true),
                    IsSelected: ko.observable(false),
                    Name: ko.observable(viewModel.SearchFilters.KeywordFilter()),
                    Label: ko.observable(option.keyWordLabel),
                    Url: ko.observable('#0'),
                    ParentName: ko.observable("KeywordFilter")
                };
                newItem.ClearFilter = function () {
                    viewModel.SearchFilters.KeywordFilter('');
                    viewModel.HasPendingUpdates(true);
                    viewModel.Search();
                };
                viewModel.SelectedFilters.push(newItem);
            }
            ko.utils.arrayForEach(viewModel.SearchFilters.ServiceFilters(), function (item) {
                if (item.IsSelected() == true) {
                    //force parent name
                    item.ParentName('ServiceFilters')
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.IndustryFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.OfficeFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.SchoolFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.LevelFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.BarAdmissionFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
            ko.utils.arrayForEach(viewModel.SearchFilters.LetterFilters(), function (item) {
                if (item.IsSelected() == true) {
                    viewModel.SelectedFilters.push(item);
                }
            });
        };

    viewModel.ClearSearch = function () {
            viewModel.SearchFilters.ClearAllSearchFilters();
            viewModel.HasPendingUpdates(true);
            viewModel.Search();
        };

    viewModel.ClearFilter = function (parentName) {
            viewModel.SearchFilters.ClearSearchFilter(parentName);
            viewModel.HasPendingUpdates(true);
            viewModel.Search();
        };

    viewModel.ResetDropdowns = function () {
            var dropdowns = $('.header-filters-list .header-filter-dropdown');
            var currentValues = dropdowns.find('span');
            var firstValues = dropdowns.find('li.drop-down-item.default > a');

            if (currentValues.length === firstValues.length) {
                for (i = 0; i < firstValues.length; i++) {
                    currentValues[i].innerHTML = firstValues[i].innerHTML;
                }
            }
        };

    viewModel.ResetDropdown = function (parentName, id) {
            if (parentName === "KeywordFilter") {

            } else if (parentName == "LetterFilters") {

            } else {
                var dropdowns = $('.header-filters-list .' + parentName.toLowerCase());
                var currentValue = dropdowns.find('span')[0];
                var firstValue = dropdowns.find('li.drop-down-item.default > a')[0];
                //Reset the is-selected classes;
                var dropDownName = parentName.toLowerCase();

                $("." + dropDownName).find(".is-selected").each(function () {
                    $(this).removeClass("is-selected");
                });
                currentValue.innerHTML = firstValue.innerHTML;
            }
        }

    viewModel.SetSelectedFilter = function (obj) {
            viewModel.SearchFilters.ClearSearchFilter(obj.ParentName());
            if(obj.ID() === '0a774288-0858-454b-af7c-1614bd4680df')
                lastChangedType = obj.ParentName();
            obj.IsSelected(true);
            viewModel.HasPendingUpdates(true);
            viewModel.Search();
        }

    // String utilities
    viewModel.DecodeHtmlInput = function (encodedString) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = encodedString;
            return textArea.value != null && textArea.value != "null" ? textArea.value : "";
        };

    viewModel.GetFilterName = function (filter) {
            if (filter.ParentName() !== "KeywordFilter") {
                return filter.Name();
            } else {
                return '"' + filter.Name() + '"';
            }
        };

    // Typeahead

    $.ajax({
            url: option.typeAheadModelUrl,
            type: "POST",
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            async: false,
            success: function (data) {
                ko.mapping.fromJS(data, {}, viewModel.TypeAheadResultGroup);
            },
            error: function (xhr, textStatus, errorThrown) {
                console.log(xhr);
                console.log("textStatus : " + textStatus);
                console.log("errorThrown : " + errorThrown);
            }
        });

    viewModel.LoadTypeAheadDataFromServer = function () {
            viewModel.IsSearchRunning(true);
            var searchTerm = viewModel.SearchFilters.KeywordFilter();
            $.ajax({
                url: option.typeAheadServiceUrl + "?query=" + encodeURIComponent(viewModel.SearchFilters.KeywordFilter()),
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                cache: false,
                success: function (data) {
                    if (viewModel.SubmissionFlag() === false) {
                        var cleanFilter = searchTerm.toLowerCase().replace(/[^a-zA-Z0-9 :]/g, "")
                        var findArray = cleanFilter.split(/,| /);
                        findArray = $.grep(findArray, function (n) { return (n); });

                        //each category
                        var preservedCaseKeywords = [];
                        var keywordIndex = 0;
                        ko.utils.arrayForEach(data, function (item) {
                            //each result item
                            keywordIndex = 0;
                            ko.utils.arrayForEach(item.Results, function (childItem) {
                                childItem.DisplayMatched = childItem.Name;
                                //each keyword to highlight in the title
                                ko.utils.arrayForEach(findArray, function (searchItem) {
                                    if (searchItem.length > 1) {
                                        var regEx = new RegExp('(' + searchItem + ')', "i");
                                        while(regEx.test(childItem.DisplayMatched)) {
                                        preservedCaseKeywords.push(regEx.exec(childItem.DisplayMatched)[0]);
                                        childItem.DisplayMatched = childItem.DisplayMatched.replace(regEx, "###_" + keywordIndex + "_###");
                                        keywordIndex++;
                                        }
                                    }
                                });
                            });
                        
                            keywordIndex = 0;
                            var containsPlaceholder = new RegExp('(###_)', "i");
                            //to prevent searching for strings contained in the html match getting double-nested, replace them all after
                            ko.utils.arrayForEach(item.Results, function (childItem) {
                                ko.utils.arrayForEach(findArray, function (searchItem) {
                                    if (searchItem.length > 1) {
                                        while(containsPlaceholder.test(childItem.DisplayMatched)) {
                                        var originalCase = preservedCaseKeywords.shift();
                                        var regEx = new RegExp('(' + "###_" + keywordIndex + "_###" + ')', "i");
                                        childItem.DisplayMatched = childItem.DisplayMatched.replace(regEx, "<strong class='keyword'>" + originalCase + "</strong>");
                                        keywordIndex++;
                                        }
                                    }
                                });
                            });
                        });
                        ko.mapping.fromJS(data, {}, viewModel.TypeAheadResultGroup);
                        viewModel.IsSearchRunning(false);
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    console.log(xhr);
                    console.log("textStatus : " + textStatus);
                    console.log("errorThrown : " + errorThrown);
                }
            });
        };

    viewModel.TypeAheadSelect = function (suggestion) {
            viewModel.SearchFilters.KeywordFilter(suggestion);
            viewModel.HasPendingUpdates(true);
            viewModel.Search();
        };

    ko.bindingHandlers.bindTypeAheadKeyUp = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var options = valueAccessor();
                var allBindings = allBindingsAccessor();
                var observable = options.observable;

                $(element).keyup(function (event) {
                    var $this = $(this);
                    var val = $this.val();

                    var keycode = (event.keyCode ? event.keyCode : event.which);

                    if (keycode != '13') {
                        viewModel.KeywordSearching(true);
                        viewModel.SubmissionFlag(false);
                    } else {
                        viewModel.SubmissionFlag(true);
                    }

                    if (!!val && val.length >= 3 && keycode !== '13') {
                        clearTimeout(typeAheadTimer);
                        typeAheadTimer = setTimeout(viewModel.LoadTypeAheadDataFromServer, 100);
                    } else {
                        viewModel.TypeAheadResultGroup.removeAll();
                    }

                    return false;
                });
            }
        };

    // Apply and load data
    viewModel.SetSelectedFilters();
    ko.applyBindings(viewModel, pageContent.get(0));

    if (viewModel.SelectedFilters().length > 0) {
            viewModel.HasSearchRun(true);
            viewModel.IsSelectAll(false);
            viewModel.IsClearAll(false);
        } else {
            viewModel.IsSelectAll(true);
            viewModel.IsClearAll(false);
        }

    // Events

    $(".letter-filter").on("click", function (event) {
            event.preventDefault();
            var context = ko.contextFor(this);
            viewModel.LetterSearch(context.$data.Name());
        });
};